import { lazy } from '../../../shared/deployment';

export const JmeWebinarEngine = lazy(() => import('./JmeWebinarEngine'));
